import Vue from 'vue';
import i18n from '@app/plugins/i18n';
import VueNoty from 'vuejs-noty';
import NotyVanila from 'noty';
import 'vuejs-noty/dist/vuejs-noty.css';
import { get_error } from '@shared/helpers/error';
import { GeneralModalService } from '@core/modals/GeneralModalService';

Vue.use(VueNoty, {
  timeout: 3000,
  theme: 'mint',
  progressBar: true
});

const HLR_ERROR_KEYS = [
  'first_column_doesnt_have_numbers',
  'illegal_symbol_in_number',
  'number_must_contain_min_max_digits',
  'too_many_rows'
];

Vue.noty.done = () => Vue.noty.success(i18n.t('shared.component.noty.done'));

const getTranslatedField = (field) => {
  const i18n_key = `shared.validation_errors.field.${field}`;
  return i18n.te(i18n_key) ? i18n.t(i18n_key) : '';
};

Vue.noty.new_server_error = (event) => {
  const oops = i18n.t('shared.component.noty.error');

  const errorArray = Object.entries(event?.response?.data);

  if (event?.response?.status === 422) {
    return errorArray?.map((i) => {
      return Vue.noty.error(
        `${getTranslatedField(i[0])} ${i[1]?.map((value) => {
          const i18n_key = `shared.validation_errors.value.${value}`;
          return i18n.te(i18n_key) ? i18n.t(i18n_key) : oops;
        }).join(', ')}`
      );
    });
  }

  return Vue.noty.error(get_error(event).message);
};

Vue.noty.server_error = (event) => {
  const R = Vue.$R;
  const rule = R.pathOr('', ['response', 'data', 'errors', 'client', 0, 'rule'], event);
  const stats_wrong_period = R.pathOr(
    '',
    ['response', 'data', 'errors', 'date_from', 0, 'message'],
    event
  );
  const stats_period_more_than_week = R.pathOr(
    '',
    ['response', 'data', 'errors', 'date_to', 0, 'message'],
    event
  );
  const trunk_ip_exists = R.pathOr('', ['response', 'data', 'errors', 'ip', 0, 'message'], event);

  const HLR_file_upload_errors = R.pathOr('', ['response', 'data', 'errors', 'file'], event);

  if (rule) return Vue.noty.error(i18n.t('voice.trunk.errors.trunk_limit'));
  if (stats_wrong_period) return Vue.noty.error(i18n.t('pbx.stat.errors.date'));
  if (stats_period_more_than_week) return Vue.noty.error(i18n.t('pbx.stat.errors.date_period'));
  if (trunk_ip_exists) return Vue.noty.error(i18n.t('voice.trunk.errors.ip_exist'));

  if (HLR_file_upload_errors.length > 0) {
    const errors_with_key = HLR_file_upload_errors.filter((i) =>
      HLR_ERROR_KEYS.includes(i.message)
    )?.map(
      (i) =>
        `${i18n.t(`core.errors.${i.message}`)}    ${
          i.parameters.row ? i18n.t(`core.errors.row`, { row: i.parameters.row }) : ''
        } `
    );
    const full_text_errors = HLR_file_upload_errors.filter(
      (i) => !HLR_ERROR_KEYS.includes(i.message)
    );

    return [...errors_with_key, ...full_text_errors]?.map((error) => Vue.noty.error(error));
  }
  
  return Vue.noty.error(get_error(event).message);
};

const get_message = (error) => {
  const isRuleExist = !!error.rule;
  const isFieldExist = !!error.field;
  const isRowExist = !!error.row_number; 
  const rule = i18n.t(`core.errors.rule.${error.rule}`);
  const field = i18n.t('core.errors.field') + ' ' + error.field;
  const row = i18n.t(`core.errors.row`, { row: error.row_number });

  const message = `${isRuleExist ? rule + '.' : ''} ${isFieldExist ? field + '.' : ''}${
    isRowExist ? row + '.' : ''
  }`;

  return message.length > 2 ? message : get_error(error).message;
};

Vue.noty.task_import_error = (event) => {
  const R = Vue.$R;
  const errors = R.pathOr('', ['response', 'data', 'errors'], event);

  if (errors) {
    const error_messages = Object.keys(errors).map((key) => {
      return {
        rule: `${errors[key][0].rule.replace('.', '')}`,
        field: `${key.split('.')[2] || key}`,
        row_number: key.split('.')[1]
      };
    });

    Vue.noty.error(
      error_messages
        .map((error) => {
          return get_message(error);
        })
        .join('\n')
    );
  } else {
    return Vue.noty.error(get_error(event).message);
  }
};

Vue.noty.popup = (text) => {
  return GeneralModalService.popup(text);
};

NotyVanila.overrideDefaults({
  timeout: 3000,
  theme: 'mint',
  progressBar: true
});

export { NotyVanila as Noty };
